import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  countryoptions1,
  currency,
  languageOptions,
  optiondeals,
  optionindustry,
  options,
  options1,
  optionschoose,
  optionsource,
  optionssymbol,
} from "../../../core/common/selectoption/selectoption";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage } from "../../../core/common/selectWithImage";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { all_routes } from "../../router/all_routes";
import { fetchAllLeads, Lead } from "../../../api/lead";
import { highlightMatch } from "../../../core/common/highlightmatch";
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";

// Define Branch interface
interface Branch {
  branch_id: string;
  branch_name: string;
  branch_address: string;
  branch_city: string;
  branch_state: string;
  branch_zipcode: string;
  branch_country: string;
  gst_number: string;
}

// Define Contact interface to match API
interface Contact {
  contact_id: string;
  company_name: string;
  company_mail: string;
  company_phone: string;
  contact_remark: string;
  website_url: string | null;
  contact_person_name: string;
  branch_name: string;
  contact_person_desigination: string;
  created_at: string;
  branch?: Branch[]; // Added branch property as optional
}

const LeadsKanban = () => {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterNames, setFilterNames] = useState<string[]>([]);
  const [filterCompanies, setFilterCompanies] = useState<string[]>([]);
  const [filterStatuses, setFilterStatuses] = useState<string[]>([]);
  const [filterOwners, setFilterOwners] = useState<string[]>([]);
  const [filterDates, setFilterDates] = useState<string[]>([]);

  const handleFilterChange = (
    value: string,
    selectedList: string[],
    setSelectedList: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (selectedList.includes(value)) {
      setSelectedList(selectedList.filter((item) => item !== value));
    } else {
      setSelectedList([...selectedList, value]);
    }
  };

  const filteredLeads = leads.filter((lead) => {
    const name = lead.contact?.contact_person_name || "";
    const company = lead.contact?.company_name || "";
    const status = lead.lead_status || "";
    const owner = lead.users?.name || "";

    const query = searchQuery.toLowerCase();
    const searchMatch =
      name.toLowerCase().includes(query) ||
      company.toLowerCase().includes(query) ||
      lead.contact?.company_mail?.toLowerCase().includes(query) ||
      lead.contact?.company_phone?.toLowerCase().includes(query);

    const nameMatch = filterNames.length === 0 || filterNames.includes(name);
    const companyMatch =
      filterCompanies.length === 0 || filterCompanies.includes(company);
    const statusMatch =
      filterStatuses.length === 0 || filterStatuses.includes(status);
    const ownerMatch =
      filterOwners.length === 0 || filterOwners.includes(owner);

    return (
      searchMatch && nameMatch && companyMatch && statusMatch && ownerMatch
    );
  });

  useEffect(() => {
    const loadLeads = async () => {
      try {
        setLoading(true);
        const data = await fetchAllLeads();
        setLeads(data);
      } catch (err) {
        console.error("Failed to load leads:", err);
        setError("Failed to load leads. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    loadLeads();
  }, []);

  const groupedLeads = filteredLeads.reduce(
    (acc: { [key: string]: Lead[] }, lead) => {
      const status = lead.lead_status || "Unknown";
      acc[status] = acc[status] || [];
      acc[status].push(lead);
      return acc;
    },
    {}
  );

  const statusColor = (status: string | undefined | null) => {
    if (!status || typeof status !== "string") return "text-muted";

    switch (status.toLowerCase()) {
      case "contacted":
        return "text-warning";
      case "not contacted":
        return "text-purple";
      case "closed":
        return "text-success";
      case "lost":
        return "text-danger";
      default:
        return "text-muted";
    }
  };

  const calculateTotalValue = (leads: Lead[]) => {
    return leads
      .reduce((total, lead) => total + Number(lead.lead_value || 0), 0)
      .toLocaleString();
  };

  const route = all_routes;

  return (
    <>
      <PageLoadProgressBar />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">
                      
                      <i className="ti ti-chart-arcs text-primary me-2" />
                      Leads<span className="count-title">{leads.length}</span>
                    </h4>
                  </div>
                  <div className="col-8 text-end">
                    <div className="head-icons">
                      <Link
                        to={route.leadsKanban}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-original-title="Refresh"
                      >
                        <i className="ti ti-refresh-dot" />
                      </Link>
                      <Link
                        to={route.leads}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-original-title="Collapse"
                        id="collapse-header"
                      >
                        <i className="ti ti-chevrons-up" />
                      </Link>
                    </div>
                    
                  </div>
                   <div className="col-sm-6">
                                  <ul className="contact-breadcrumb">
                                    <li>
                                      <Link to={route.leads}>
                                        <i className="ti ti-arrow-narrow-left" />
                                        Leads
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                </div>
               
              </div>
              {/* /Page Header */}
              {/* Filter */}
              <div className="d-flex justify-content-between align-items-center flex-wrap row-gap-2 mb-4">
                <div className="d-flex align-items-center flex-wrap row-gap-2">
                  <div className="form-sorts dropdown me-2">
                    <Link
                      to="#"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                    >
                      <i className="ti ti-filter-share" />
                      Filter
                    </Link>
                    <div className="filter-dropdown-menu dropdown-menu dropdown-menu-start">
                      <div className="filter-set-view">
                        <div className="filter-set-head">
                          <h4>
                            <i className="ti ti-filter-share" />
                            Filter
                          </h4>
                        </div>
                        <div className="accordion" id="accordionExample">
                          <div className="filter-set-content">
                            <div className="filter-set-content-head">
                              <Link
                                to="#"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo"
                                aria-expanded="true"
                                aria-controls="collapseTwo"
                              >
                                Lead Name
                              </Link>
                            </div>
                            <div
                              className="filter-set-contents accordion-collapse collapse show"
                              id="collapseTwo"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="filter-content-list">
                                <ul>
                                  {Array.from(
                                    new Set(
                                      leads.map(
                                        (lead) =>
                                          lead.contact?.contact_person_name
                                      )
                                    )
                                  )
                                    .filter(Boolean)
                                    .map((name) => (
                                      <li key={name}>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              checked={filterNames.includes(
                                                name!
                                              )}
                                              onChange={() =>
                                                handleFilterChange(
                                                  name!,
                                                  filterNames,
                                                  setFilterNames
                                                )
                                              }
                                            />
                                            <span className="checkmarks" />
                                          </label>
                                        </div>
                                        <div className="collapse-inside-text">
                                          <h5>{name}</h5>
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="filter-set-content">
                            <div className="filter-set-content-head">
                              <Link
                                to="#"
                                className="collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#company"
                                aria-expanded="false"
                                aria-controls="company"
                              >
                                Company Name
                              </Link>
                            </div>
                            <div
                              className="filter-set-contents accordion-collapse collapse"
                              id="company"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="filter-content-list">
                                <div className="mb-2 icon-form">
                                  <span className="form-icon">
                                    <i className="ti ti-search" />
                                  </span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Company"
                                  />
                                </div>
                                <ul>
                                  {Array.from(
                                    new Set(
                                      leads.map(
                                        (lead) => lead.contact?.company_name
                                      )
                                    )
                                  )
                                    .filter(Boolean)
                                    .map((company) => (
                                      <li key={company}>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              checked={filterCompanies.includes(
                                                company!
                                              )}
                                              onChange={() =>
                                                handleFilterChange(
                                                  company!,
                                                  filterCompanies,
                                                  setFilterCompanies
                                                )
                                              }
                                            />
                                            <span className="checkmarks" />
                                          </label>
                                        </div>
                                        <div className="collapse-inside-text">
                                          <h5>{company}</h5>
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="filter-set-content">
                            <div className="filter-set-content-head">
                              <Link
                                to="#"
                                className="collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#Status"
                                aria-expanded="false"
                                aria-controls="Status"
                              >
                                Lead Status
                              </Link>
                            </div>
                            <div
                              className="filter-set-contents accordion-collapse collapse"
                              id="Status"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="filter-content-list">
                                <ul>
                                  {Array.from(
                                    new Set(
                                      leads.map((lead) => lead.lead_status)
                                    )
                                  )
                                    .filter(Boolean)
                                    .map((status) => (
                                      <li key={status}>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              checked={filterStatuses.includes(
                                                status!
                                              )}
                                              onChange={() =>
                                                handleFilterChange(
                                                  status!,
                                                  filterStatuses,
                                                  setFilterStatuses
                                                )
                                              }
                                            />
                                            <span className="checkmarks" />
                                          </label>
                                        </div>
                                        <div className="collapse-inside-text">
                                          <h5>{status}</h5>
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="filter-set-content">
                            <div className="filter-set-content-head">
                              <Link
                                to="#"
                                className="collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#date"
                                aria-expanded="false"
                                aria-controls="date"
                              >
                                Created Date
                              </Link>
                            </div>
                            <div
                              className="filter-set-contents accordion-collapse collapse"
                              id="date"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="filter-content-list">
                                <ul>
                                  {Array.from(
                                    new Set(
                                      leads.map((lead) =>
                                        lead.created_at
                                          ? new Date(
                                              lead.created_at
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            })
                                          : null
                                      )
                                    )
                                  )
                                    .filter(Boolean)
                                    .map((date) => (
                                      <li key={date}>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              checked={filterDates.includes(
                                                date!
                                              )}
                                              onChange={() =>
                                                handleFilterChange(
                                                  date!,
                                                  filterDates,
                                                  setFilterDates
                                                )
                                              }
                                            />
                                            <span className="checkmarks" />
                                          </label>
                                        </div>
                                        <div className="collapse-inside-text">
                                          <h5>{date}</h5>
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="filter-set-content">
                            <div className="filter-set-content-head">
                              <Link
                                to="#"
                                className="collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#owner"
                                aria-expanded="false"
                                aria-controls="owner"
                              >
                                Lead Owner
                              </Link>
                            </div>
                            <div
                              className="filter-set-contents accordion-collapse collapse"
                              id="owner"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="filter-content-list">
                                <div className="mb-2 icon-form">
                                  <span className="form-icon">
                                    <i className="ti ti-search" />
                                  </span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Owner"
                                  />
                                </div>
                                <ul>
                                  {Array.from(
                                    new Set(
                                      leads.map((lead) => lead.users?.name)
                                    )
                                  )
                                    .filter(Boolean)
                                    .map((owner) => (
                                      <li key={owner}>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              checked={filterOwners.includes(
                                                owner!
                                              )}
                                              onChange={() =>
                                                handleFilterChange(
                                                  owner!,
                                                  filterOwners,
                                                  setFilterOwners
                                                )
                                              }
                                            />
                                            <span className="checkmarks" />
                                          </label>
                                        </div>
                                        <div className="collapse-inside-text">
                                          <h5>{owner}</h5>
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="filter-reset-btns">
                          <div className="row">
                            <div className="col-6">
                              <Link
                                to="#"
                                className="btn btn-light"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setFilterNames([]);
                                  setFilterCompanies([]);
                                  setFilterStatuses([]);
                                  setFilterOwners([]);
                                  setFilterDates([]);
                                }}
                              >
                                Reset
                              </Link>
                            </div>
                            <div className="col-6">
                              <Link
                                to={route.leadsKanban}
                                className="btn btn-primary"
                              >
                                Filter
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Leads"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
                <div>
                  <ul className="d-flex align-items-center">
                    <li>
                      <div className="view-icons me-2">
                        <Link to={route.leads}>
                          <i className="ti ti-list-tree" />
                        </Link>
                        <Link to={route.leadsKanban} className="active">
                          <i className="ti ti-grid-dots" />
                        </Link>
                      </div>
                    </li>
                    {/* <li>
                      <Link
                        to="#"
                        className="btn btn-primary"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvas_add"
                      >
                        <i className="ti ti-square-rounded-plus me-2" />
                        Add Leads
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
              {/* /Filter */}
              {/* Leads Kanban */}
             {loading ? (
  <div className="alert alert-info">Loading leads...</div>
) : error ? (
  <div className="alert alert-danger">{error}</div>
) : leads.length === 0 ? (
  <div className="alert alert-warning">No leads found.</div>
) : (
  <div className="d-flex overflow-x-auto align-items-start mb-4">
    {Object.entries(groupedLeads).map(([status, leadsInStatus]) => (
      <div className="kanban-list-items" key={status}>
        <div className="card border contact-card">
          <div className="card-body bg-light border-bottom rounded-top">
            <h4 className="fw-semibold d-flex align-items-center mb-1">
              <i
                className={`ti ti-circle-filled fs-8 me-2 ${statusColor(status)}`}
              />
              {status}
            </h4>
            <span className="fw-medium text-muted small">
              {leadsInStatus.length} Leads • ₹{calculateTotalValue(leadsInStatus)}
            </span>
          </div>
        </div>

        <div className="kanban-drag-wrap pt-4">
          {leadsInStatus.map((lead) => (
            <div className="card kanban-card border" key={lead.lead_id}>
              <div className="card-body">
                <div className="d-block">
                  <div className={`${statusColor(status)} border border-2 mb-3`} />

                  <div className="d-flex align-items-center mb-3">
                    <Link
                      to={route.leadsDetails}
                      state={leads}
                      className="avatar avatar-lg bg-gray flex-shrink-0 me-2"
                    >
                      <span className="avatar-title text-dark">
                        {lead.contact?.contact_person_name
                          ?.substring(0, 2)
                          .toUpperCase() || "NA"}
                      </span>
                    </Link>

                    <div className="d-flex flex-column">
                      <h6 className="fw-medium mb-1">
                        <Link
                          to={route.leadsDetails}
                          state={lead}
                          className="text-dark"
                        >
                          {highlightMatch(
                            lead.contact?.contact_person_name || "Unknown",
                            searchQuery
                          )}
                        </Link>
                      </h6>
                      <p className="text-muted mb-0 fs-14">
                        {highlightMatch(lead.contact?.company_name || "N/A", searchQuery)}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mb-3 d-flex flex-column">
                  <p className="text-default d-inline-flex align-items-center mb-2">
                    <i className="ti ti-report-money text-dark me-1" />
                    {highlightMatch(lead.lead_value || "N/A", searchQuery)}
                  </p>
                  <p className="text-default d-inline-flex align-items-center mb-2">
                    <i className="ti ti-mail text-dark me-1" />
                    {highlightMatch(lead.contact?.company_mail || "N/A", searchQuery)}
                  </p>
                  <p className="text-default d-inline-flex align-items-center mb-2">
                    <i className="ti ti-phone text-dark me-1" />
                    {highlightMatch(lead.contact?.company_phone || "N/A", searchQuery)}
                  </p>
                  <p className="text-default d-inline-flex align-items-center">
                    <i className="ti ti-map-pin-pin text-dark me-1" />
                    {highlightMatch(lead.contact?.branch?.[1]?.branch_name || "N/A", searchQuery)}
                    ,{" "}
                    {highlightMatch(lead.contact?.branch?.[0]?.branch_city || "N/A", searchQuery)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
)}

              {/* /Leads Kanban */}
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </div>
    </>
  );
};

export default LeadsKanban;
